import { call, put, select, takeLatest } from 'redux-saga/effects';
import { AxiosResponse } from 'axios';

import { ActionType, ReprocessCreateRequestedAction } from './types';
import { SalesReprocessApi, AppStorage, FindReprocessResponse } from '../../services';
import {
  reprocessParametersSuccess,
  reprocessParametersFailure,
  reprocessFindFailure,
  reprocessFindSuccess,
  reprocessCreateFailure,
  reprocessCreateSuccess,
} from './actionCreators';
import { AppParameters, HttpRequestError, ReprocessFilter } from '../../types';
import {
  createReprocessRequestMap,
  createReprocessSalesPARequestMap,
  findReprocessRequestMap,
  findReprocessResponseMap,
} from '../../helpers';
import { filterParametersDataSelector, reprocessFilterSelector } from '../selectors';

interface ExtendedAppParameters extends AppParameters {
  reprocess?: {
    statuses: string[];
    configuration?: {
      max_date_range: number;
    };
  };
}

function* getParameters() {
  try {
    const globalParameters: ExtendedAppParameters | undefined = yield select(
      filterParametersDataSelector
    );

    let reprocessParameters = AppStorage.getReprocessParameters();

    if (globalParameters && globalParameters.reprocess) {
      reprocessParameters = {
        statuses: globalParameters.reprocess.statuses,

        configuration: globalParameters.reprocess.configuration,
      };

      AppStorage.setReprocessParameters(reprocessParameters);
    }

    if (!reprocessParameters) {
      throw new Error('No se pudieron cargar los parámetros de reproceso (Global/Storage)');
    }

    const safePayload = reprocessParameters || { statuses: [] };

    yield put(reprocessParametersSuccess(safePayload));
  } catch (error) {
    yield put(reprocessParametersFailure(error as HttpRequestError));
  }
}

function* findReprocess() {
  const filters: ReprocessFilter = yield select(reprocessFilterSelector);

  try {
    const { data }: AxiosResponse<FindReprocessResponse> = yield call(
      SalesReprocessApi.findReprocess,
      findReprocessRequestMap(filters)
    );
    yield put(reprocessFindSuccess(findReprocessResponseMap(data)));
  } catch (error) {
    yield put(reprocessFindFailure(error as HttpRequestError));
  }
}

function* createReprocess({ payload }: ReprocessCreateRequestedAction) {
  try {
    if (payload.country === 'PA' && payload.store) {
      yield call(
        SalesReprocessApi.createReprocessSalesPA,
        createReprocessSalesPARequestMap(payload)
      );
    } else {
      yield call(SalesReprocessApi.createReprocess, createReprocessRequestMap(payload));
    }
    yield put(reprocessCreateSuccess());
  } catch (error) {
    yield put(reprocessCreateFailure(error as HttpRequestError));
  }
}
export default [
  takeLatest(ActionType.reprocessParametersRequested, getParameters),
  takeLatest(ActionType.reprocessFindRequested, findReprocess),
  takeLatest(ActionType.reprocessCreateRequested, createReprocess),
];
